import { searchResults as TYPES } from './../action_types';

const initialState = {
  //tab: undefined,
  models: {},
  page: {},
  total: {},
  researchInterests: {},
  actors: {},
  meta: {
    fetching: false,
    errorFetching: false,
  },
};

export function SearchResults(state = initialState, action) {
  switch (action.type) {
    case TYPES.UPDATE_WORKS:
      // merge existing works with new data
      // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
      // eslint-disable-next-line no-case-declarations
      const { tab, models, relatedUpsellResults } = state;
      // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
      // eslint-disable-next-line no-case-declarations
      const mergeWork = (work) => ({ ...work, ...action.works[work.id] });
      // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
      // eslint-disable-next-line no-case-declarations
      const updatedModels = models[tab].map(mergeWork);
      // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
      // eslint-disable-next-line no-case-declarations
      const updatedRelated = relatedUpsellResults
        ? relatedUpsellResults.map(mergeWork)
        : null;

      return {
        ...state,
        models: { ...models, [tab]: updatedModels },
        relatedUpsellResults: updatedRelated,
      };

    case TYPES.FETCH_RI_FOLLOWER_COUNT_SUCCESS:
      var newInterest = {};
      var interest = state.researchInterests[action.interest.id];

      if (interest != null) {
        newInterest[action.interest.id] = {
          ...interest,
          followerCount: action.followerCount,
        };
      } else {
        newInterest[action.interest.id] = {
          ...action.interest,
          followerCount: action.followerCount,
        };
      }

      return {
        ...state,
        researchInterests: { ...state.researchInterests, ...newInterest },
      };

    case TYPES.FETCH_ACTOR_DATA_SUCCESS:
      var newActor = {};
      // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
      // eslint-disable-next-line no-case-declarations
      const actorId = action.actor.id;
      // actors not followed by current user are unknown to the store until async data is requested
      // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
      // eslint-disable-next-line no-case-declarations
      const actor = state.actors[actorId];
      if (actor != null) {
        newActor[actorId] = { ...actor };
      } else {
        newActor[actorId] = { ...action.actor, isFollowing: false };
      }

      if (action.viewCount != null) {
        newActor[actorId].viewCount = action.viewCount;
      }
      if (action.workCount != null) {
        newActor[actorId].workCount = action.workCount;
      }
      if (action.followerCount != null) {
        newActor[actorId].followerCount = action.followerCount;
      }

      return {
        ...state,
        actors: { ...state.actors, ...newActor },
      };

    case TYPES.FOLLOW_USER_SUCCESS:
      var newFollowee = {};
      // actor may need to be added to the store if async data fetching failed
      var followee = state.actors[action.followeeId];
      if (followee != null) {
        newFollowee[action.followeeId] = { ...followee, isFollowing: true };
      } else {
        newFollowee[action.followeeId] = {
          id: action.followeeId,
          isFollowing: true,
        };
      }

      return {
        ...state,
        actors: { ...state.actors, ...newFollowee },
      };

    case TYPES.UNFOLLOW_USER_SUCCESS:
      var newUnfollowee = {};
      var unfollowee = state.actors[action.unfolloweeId];
      if (unfollowee != null) {
        newUnfollowee[action.unfolloweeId] = {
          ...unfollowee,
          isFollowing: false,
        };
      } else {
        newUnfollowee[action.unfolloweeId] = {
          id: action.followeeId,
          isFollowing: false,
        };
      }

      return {
        ...state,
        actors: { ...state.actors, ...newUnfollowee },
      };

    case TYPES.FOLLOW_RI_SUCCESS:
      var followedInterest = {};
      // RI may need to be added to the store if async data fetching failed
      // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
      // eslint-disable-next-line @typescript-eslint/no-redeclare
      var interest = state.researchInterests[action.interest.id];
      if (interest != null) {
        followedInterest[action.interest.id] = {
          ...interest,
          isFollowing: true,
        };
      } else {
        followedInterest[action.interest.id] = {
          ...action.interest,
          isFollowing: true,
        };
      }

      return {
        ...state,
        researchInterests: { ...state.researchInterests, ...followedInterest },
      };

    case TYPES.UNFOLLOW_RI_SUCCESS:
      var unfollowedInterest = {};
      // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
      // eslint-disable-next-line @typescript-eslint/no-redeclare
      var interest = state.researchInterests[action.interest.id];
      if (interest != null) {
        unfollowedInterest[action.interest.id] = {
          ...interest,
          isFollowing: false,
        };
      } else {
        unfollowedInterest[action.interest.id] = {
          ...action.interest,
          isFollowing: false,
        };
      }

      return {
        ...state,
        researchInterests: {
          ...state.researchInterests,
          ...unfollowedInterest,
        },
      };

    default:
      return state;
  }
}
